"use client";

import { useEffect, useState } from "react";

/**
 * True once `delayMs` has passed with the page in front of the reader. The
 * clock starts only when the document is visible, so a page opened in a
 * background tab starts counting when it is shown and the moment is not spent
 * where nobody sees it. Once started, the clock runs to the end.
 */
export function useVisibleDelay(delayMs: number, isEnabled = true) {
  const [hasElapsed, setHasElapsed] = useState(false);

  useEffect(() => {
    if (!isEnabled || hasElapsed) return;

    let timer: number | undefined;

    const start = () => {
      if (document.visibilityState !== "visible" || timer !== undefined) return;

      timer = window.setTimeout(() => setHasElapsed(true), delayMs);
    };

    start();
    document.addEventListener("visibilitychange", start);

    return () => {
      document.removeEventListener("visibilitychange", start);
      window.clearTimeout(timer);
    };
  }, [delayMs, isEnabled, hasElapsed]);

  return hasElapsed;
}
